<template>
  <div class="main-window-l">
    <div class="step-nav">
      <div class="nav-item active">
        电子证信息
      </div>
    </div>

    <div class="contain-box">
      <div class="item-l">
        <img class="head-photo" :src="guestData.headPhoto" />
        <div>
          <div>
            <span
              v-for="(item, index) in guestData.guestTypeList"
              :key="index"
              class="tag"
            >{{ item | mapFilter(guestTypeMap) }}</span>
          </div>
          <div class="name-box">
            <p>{{ guestData.guestName }}</p>
            <p v-if="guestData.guestTypeList.includes('14')">{{ guestData.company }}</p>
          </div>
          <div v-if="!guestData.guestTypeList.includes('15')">
            <span class="title">预约活动：</span>
            <p v-if="guestData.activityNameList">{{ guestData.activityNameList }}</p>
            <p v-else class="remind-text">暂无预约数据</p>
          </div>
          <div v-if="guestData.guestTypeList.includes('15')">
            <span class="title">参与活动名称：</span>
            <template v-if="guestData.conferenceName">
              <p v-for="(item, index) in guestData.conferenceName.split(',')" :key="index">{{ item }}</p>
            </template>
          </div>
        </div>
      </div>
      <img class="code-img" :src="codeUrl" />
    </div>
    <div class="foo foo-center">
      <button class="leftBtn" @click="goBack">返回</button>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { sessionData } from "@/static/js/local.js";
import { industryApi } from '@/api/industry';

const guestTypeMap = new Map([
  ['10', '创投嘉宾'],
  ['11', '项目方嘉宾'],
  ['13', '市场嘉宾'],
  ['14', '媒体嘉宾'],
  ['15', '发布会嘉宾']
])

export default {
  data() {
    return {
      guestTypeMap: guestTypeMap,
      codeUrl: '',
      guestData: {
        headPhoto: '',
        guestName: '',
        guestTypeList: [],
        activityNameList: []
      }
    };
  },
  created() {
    let userInfo = sessionData("get", "UserInfo");
    if (userInfo && userInfo.accountId) {
      this.getCode(userInfo.accountId);
    } else {
      this.$message.warning('请先登录');
      this.goBack();
    }
  },
  methods: {
    getCode(accountId) {
      industryApi.getCode({
        accountId,
        mainId: this.$session.get("cmm").mainId
      }).then(async res => {
        this.codeUrl = await QRCode.toDataURL(res.data.codeData, {
          width: 1000,
          height: 1000
        })
        this.guestData = Object.assign({}, res.data.guestData);
        if (res.data.guestData.activityNameList) {
          this.guestData.activityNameList = res.data.guestData.activityNameList.join('；');
        }
      })
    },
    goBack() {
      this.$router.push('/userIndex');
    }
  }
};
</script>

<style src="../../../static/css/regist.css" scoped></style>

<style scoped>
.contain-box {
  padding: 20px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.contain-box .item-l {
  display: flex;
}

.contain-box .head-photo {
  margin-right: 30px;
  width: 180px;
  height: 240px;
  background: #ddd;
  object-fit: contain;
}
.contain-box .code-img {
  width: 150px;
  height: 150px;
}

.contain-box .tag {
  margin-right: 10px;
  padding: 4px 8px;
  width: max-content;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #fff;
  background: #C1A17B;
}

.contain-box .name-box {
  margin: 10px 0;
  font-size: 18px;
}
.contain-box .title {
  color: #C1A17B;
}
</style>